import React, { Component } from "react";

const container = {
  margin: 'auto',
  width: '50%'
};

const errorStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)'
};

export class FourOhFour extends Component {
  displayName = FourOhFour.name;

  render() {
    return (
      <div style={container}>
        <h3 style={errorStyles}>
          404 - The page you were looking for could not be found.
        </h3>
      </div>
    );
  }
}
